import { isValidEmailFormat } from "../../libs/is-valid-email-format";

const validateEditDetails = (activity) => {
    const errors = {};

    errors.name = (
        activity.name === ""
        || activity.name === null
        || activity.name === undefined
    )
        ? " "
        : "";

    errors.eventType = (
        activity.eventType === ""
        || activity.eventType === null
        || activity.eventType === undefined
    )
        ? "Choose an event type"
        : "";

    errors.ages = (
        activity.ages === null
        || activity.ages === undefined
        || activity.ages?.length <= 0
    )
        ? "Choose an age"
        : "";

    errors.description = (
        activity.description === ""
        || activity.description === null
        || activity.description === undefined
    )
        ? "Enter a description"
        : "";

    errors.img = (
        activity.img === ""
        || activity.img === null
        || activity.img === undefined
    )
        ? "Choose a picture"
        : "";

    errors.primaryCategory = (
        activity.primaryCategory === ""
        || activity.primaryCategory === null
        || activity.primaryCategory === undefined
    )
        ? "Choose a category"
        : "";

    errors.bookingEmail = (
        activity.bookingEmail === ""
        || activity.bookingEmail === null
        || activity.bookingEmail === undefined
        || isValidEmailFormat(activity.bookingEmail) === false
    )
        ? "Enter a booking email"
        : "";

    errors.bookingType = (
        activity.bookingType === null
        || activity.bookingType === ""
        || activity.bookingType === undefined
    )
        ? "Choose an attendance type"
        : "";

    return errors;
};

export default validateEditDetails;
